import EA from '../helpers/init';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default EA.Methods.projectDetailSwiper = ($this) => {
    const swiperEl = $this.querySelector('.swiper-container');
    const prev = $this.querySelector('.swiper-button-prev');
    const next = $this.querySelector('.swiper-button-next');
    
    new Swiper( swiperEl, {
        speed: 1000,
        modules: [Navigation],
        slidesPerView: 1.05,
        spaceBetween: 20,
        slidesOffsetAfter: 20,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            800: {
                slidesPerView: 'auto',
                spaceBetween: 32
            }
        }
    });
};
